// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hole-events-tables {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

/* Header */
.hole-events-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f9fafb; /* gray-50 */
  border-radius: 0.375rem;
  border: 1px solid #d1d5db; /* gray-300 */
}

.header-info h3 {
  margin: 0 0 0.5rem 0;
  color: #111827; /* gray-900 */
  font-size: 1.125rem;
  font-weight: 600;
}

.header-info p {
  margin: 0;
  color: #6b7280; /* gray-500 */
  font-size: 0.875rem;
}

.header-actions {
  display: flex;
  gap: var(--spacing-sm);
}

/* Loading and Error States */
.hole-events-loading,
.hole-events-error {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.hole-events-loading-spinner {
  text-align: center;
}

.hole-events-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--bg-tertiary);
  border-top: 4px solid var(--primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto var(--spacing-md);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-content {
  text-align: center;
}

.error-content h3 {
  color: var(--danger);
  margin-bottom: var(--spacing-sm);
}

.error-content p {
  color: var(--text-secondary);
  margin-bottom: var(--spacing-md);
}

/* Table Sections */
.skins-table-section,
.saw-offs-table-section {
  overflow: hidden;
}

.table-header {
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb; /* gray-200 */
  background: #f9fafb; /* gray-50 */
}

.table-header h4 {
  margin: 0 0 0.5rem 0;
  color: #111827; /* gray-900 */
  font-size: 1.125rem;
  font-weight: 600;
}

.table-header p {
  margin: 0;
  color: #6b7280; /* gray-500 */
  font-size: 0.875rem;
}

.empty-state {
  padding: var(--spacing-2xl);
  text-align: center;
  color: var(--text-secondary);
}

/* Table Styles */
.table-container {
  overflow-x: auto;
}

.hole-events-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-sm);
}

.hole-events-table th {
  background: #f3f4f6; /* gray-100 */
  color: #374151; /* gray-700 */
  font-weight: 600;
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb; /* gray-200 */
  white-space: nowrap;
  font-size: 0.875rem;
}

.hole-events-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #f3f4f6; /* gray-100 */
  vertical-align: middle;
  font-size: 0.875rem;
}

.hole-events-table tbody tr:hover {
  background: #f9fafb; /* gray-50 */
}

.hole-events-table tbody tr:last-child td {
  border-bottom: none;
}

/* Player Info */
.player-info {
  display: flex;
  flex-direction: column;
}

.player-info strong {
  color: #111827; /* gray-900 */
  font-weight: 600;
}

.player-info small {
  color: #6b7280; /* gray-500 */
  font-size: 0.75rem;
  margin-top: 2px;
}

/* Score Styling */
.score-under-par {
  color: #10b981; /* green-500 */
  font-weight: 600;
}

.score-par {
  color: #374151; /* gray-700 */
  font-weight: 600;
}

.score-over-par {
  color: #f59e0b; /* amber-500 */
  font-weight: 600;
}

.score-no-par {
  color: #6b7280; /* gray-500 */
  font-weight: 600;
}

/* Prize Amount */
.prize-amount {
  color: #059669; /* emerald-600 */
  font-weight: 600;
  font-family: 'Courier New', monospace;
}

/* Result Badge */
.result-badge {
  display: inline-block;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: 600;
  text-transform: uppercase;
}

.result-skin {
  background: #059669; /* emerald-600 */
  color: white;
}

.result-saw-off {
  background: #d97706; /* amber-600 */
  color: white;
}

/* Summary Stats */
.hole-events-summary {
  background: #f9fafb; /* gray-50 */
  border: 1px solid #e5e7eb; /* gray-200 */
}

.hole-events-summary h4 {
  margin: 0 0 1rem 0;
  color: #111827; /* gray-900 */
  font-size: 1.125rem;
  font-weight: 600;
}

.summary-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-md);
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: white;
  border-radius: 0.375rem;
  border: 1px solid #e5e7eb; /* gray-200 */
}

.stat-label {
  color: #6b7280; /* gray-500 */
  font-size: 0.875rem;
}

.stat-value {
  color: #111827; /* gray-900 */
  font-weight: 600;
  font-size: 0.875rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hole-events-header {
    flex-direction: column;
    gap: var(--spacing-md);
    align-items: stretch;
  }

  .header-actions {
    justify-content: center;
  }

  .summary-stats {
    grid-template-columns: 1fr;
  }

  .hole-events-table {
    font-size: var(--font-size-xs);
  }

  .hole-events-table th,
  .hole-events-table td {
    padding: var(--spacing-sm);
  }
}

@media (max-width: 480px) {
  .hole-events-table th,
  .hole-events-table td {
    padding: var(--spacing-xs);
  }

  .player-info small {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/tournament/HoleEventsTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB,EAAE,YAAY;EACjC,uBAAuB;EACvB,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;EACE,oBAAoB;EACpB,cAAc,EAAE,aAAa;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc,EAAE,aAAa;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC,EAAE,aAAa;EAC/C,mBAAmB,EAAE,YAAY;AACnC;;AAEA;EACE,oBAAoB;EACpB,cAAc,EAAE,aAAa;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc,EAAE,aAAa;EAC7B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB,EAAE,aAAa;EAClC,cAAc,EAAE,aAAa;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC,EAAE,aAAa;EAC/C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC,EAAE,aAAa;EAC/C,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,YAAY;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc,EAAE,gBAAgB;EAChC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;EACrC,YAAY;AACd;;AAEA;EACE,mBAAmB,EAAE,cAAc;EACnC,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,mBAAmB,EAAE,YAAY;EACjC,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;EACE,kBAAkB;EAClB,cAAc,EAAE,aAAa;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,aAAa;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".hole-events-tables {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n/* Header */\n.hole-events-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: #f9fafb; /* gray-50 */\n  border-radius: 0.375rem;\n  border: 1px solid #d1d5db; /* gray-300 */\n}\n\n.header-info h3 {\n  margin: 0 0 0.5rem 0;\n  color: #111827; /* gray-900 */\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n.header-info p {\n  margin: 0;\n  color: #6b7280; /* gray-500 */\n  font-size: 0.875rem;\n}\n\n.header-actions {\n  display: flex;\n  gap: var(--spacing-sm);\n}\n\n/* Loading and Error States */\n.hole-events-loading,\n.hole-events-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.hole-events-loading-spinner {\n  text-align: center;\n}\n\n.hole-events-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--bg-tertiary);\n  border-top: 4px solid var(--primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto var(--spacing-md);\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-content {\n  text-align: center;\n}\n\n.error-content h3 {\n  color: var(--danger);\n  margin-bottom: var(--spacing-sm);\n}\n\n.error-content p {\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-md);\n}\n\n/* Table Sections */\n.skins-table-section,\n.saw-offs-table-section {\n  overflow: hidden;\n}\n\n.table-header {\n  padding: 1rem;\n  border-bottom: 1px solid #e5e7eb; /* gray-200 */\n  background: #f9fafb; /* gray-50 */\n}\n\n.table-header h4 {\n  margin: 0 0 0.5rem 0;\n  color: #111827; /* gray-900 */\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n.table-header p {\n  margin: 0;\n  color: #6b7280; /* gray-500 */\n  font-size: 0.875rem;\n}\n\n.empty-state {\n  padding: var(--spacing-2xl);\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n/* Table Styles */\n.table-container {\n  overflow-x: auto;\n}\n\n.hole-events-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--font-size-sm);\n}\n\n.hole-events-table th {\n  background: #f3f4f6; /* gray-100 */\n  color: #374151; /* gray-700 */\n  font-weight: 600;\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb; /* gray-200 */\n  white-space: nowrap;\n  font-size: 0.875rem;\n}\n\n.hole-events-table td {\n  padding: 0.75rem;\n  border-bottom: 1px solid #f3f4f6; /* gray-100 */\n  vertical-align: middle;\n  font-size: 0.875rem;\n}\n\n.hole-events-table tbody tr:hover {\n  background: #f9fafb; /* gray-50 */\n}\n\n.hole-events-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Player Info */\n.player-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.player-info strong {\n  color: #111827; /* gray-900 */\n  font-weight: 600;\n}\n\n.player-info small {\n  color: #6b7280; /* gray-500 */\n  font-size: 0.75rem;\n  margin-top: 2px;\n}\n\n/* Score Styling */\n.score-under-par {\n  color: #10b981; /* green-500 */\n  font-weight: 600;\n}\n\n.score-par {\n  color: #374151; /* gray-700 */\n  font-weight: 600;\n}\n\n.score-over-par {\n  color: #f59e0b; /* amber-500 */\n  font-weight: 600;\n}\n\n.score-no-par {\n  color: #6b7280; /* gray-500 */\n  font-weight: 600;\n}\n\n/* Prize Amount */\n.prize-amount {\n  color: #059669; /* emerald-600 */\n  font-weight: 600;\n  font-family: 'Courier New', monospace;\n}\n\n/* Result Badge */\n.result-badge {\n  display: inline-block;\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-xs);\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.result-skin {\n  background: #059669; /* emerald-600 */\n  color: white;\n}\n\n.result-saw-off {\n  background: #d97706; /* amber-600 */\n  color: white;\n}\n\n/* Summary Stats */\n.hole-events-summary {\n  background: #f9fafb; /* gray-50 */\n  border: 1px solid #e5e7eb; /* gray-200 */\n}\n\n.hole-events-summary h4 {\n  margin: 0 0 1rem 0;\n  color: #111827; /* gray-900 */\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n.summary-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--spacing-md);\n}\n\n.stat-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background: white;\n  border-radius: 0.375rem;\n  border: 1px solid #e5e7eb; /* gray-200 */\n}\n\n.stat-label {\n  color: #6b7280; /* gray-500 */\n  font-size: 0.875rem;\n}\n\n.stat-value {\n  color: #111827; /* gray-900 */\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hole-events-header {\n    flex-direction: column;\n    gap: var(--spacing-md);\n    align-items: stretch;\n  }\n\n  .header-actions {\n    justify-content: center;\n  }\n\n  .summary-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .hole-events-table {\n    font-size: var(--font-size-xs);\n  }\n\n  .hole-events-table th,\n  .hole-events-table td {\n    padding: var(--spacing-sm);\n  }\n}\n\n@media (max-width: 480px) {\n  .hole-events-table th,\n  .hole-events-table td {\n    padding: var(--spacing-xs);\n  }\n\n  .player-info small {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
